import {
    Directive,
    Input,
    Output,
    EventEmitter,
    OnInit,
    OnChanges,
    SimpleChanges,
    ElementRef,
    Renderer2,
    SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
    selector: '[mappTypingEffect]',
    standalone: true,
})
export default class TypingEffectDirective implements OnInit, OnChanges {
    @Input() typingText = '';

    @Input() speed = 5; // Speed of typing (milliseconds)

    @Input() pause = false; // Pause on demand

    @Output() typingFinished: EventEmitter<void> = new EventEmitter<void>();

    index = 0;

    /**
     *
     * @param el
     * @param renderer
     * @param sanitizer
     */
    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private sanitizer: DomSanitizer
    ) {}

    /**
     *
     */
    ngOnInit() {
        this.type();
    }

    /**
     *
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges) {
        // React to changes in the 'pause' input
        if (changes.pause) {
            if (this.pause) {
                // Pause typing
                clearTimeout(this.timeoutId);
            } else {
                // Resume typing
                this.type();
            }
        }
    }

    private timeoutId: any;

    /**
     *
     */
    private type() {
        if (this.index < this.typingText.length && !this.pause) {
            const content = this.typingText.slice(0, this.index + 1);
            const sanitizedContent = this.sanitizer.sanitize(SecurityContext.HTML, content);
            this.renderer.setProperty(this.el.nativeElement, 'innerHTML', sanitizedContent || '');

            this.index += 1;
            this.scrollToBottom();
            this.timeoutId = setTimeout(() => {
                this.type();
            }, this.speed); // Adjust the speed of typing here (milliseconds)
        } else {
            // Typing finished, emit event
            this.typingFinished.emit();
        }
    }

    /**
     *
     */
    private scrollToBottom() {
        // Find the nearest scrollable container dynamically
        let { parentElement } = this.el.nativeElement;
        while (parentElement) {
            if (parentElement.scrollHeight > parentElement.clientHeight) {
                // Found a scrollable container
                parentElement.scrollTop = parentElement.scrollHeight;
                return;
            }
            parentElement = parentElement.parentElement;
        }
    }
}
